import React, { memo, useEffect, useState } from 'react';
import classnames from 'classnames';
import Iconfont from '@gp/components/Iconfont';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import GeneralModal from '@gp/components/GeneralModal';
import InfoBubble from '@gp/components/InfoBubble';
import LogoListDetails from '@gp/pages/StudioDashboard/StudioOverall/components/LogoList/components/LogoListDetails';
import useLogoListCalc from '@gp/pages/StudioDashboard/StudioOverall/components/LogoList/hooks/useLogoListCalc';
import '@gp/pages/StudioDashboard/StudioOverall/components/LogoList/index.scss';

const LogoList: React.FC<ILogoListProps> = (props) => {
  const {
    title,
    logos,
    defaultLogo,
    getBubbleMsg,
    className,
    style,
    isModalShowItemDate = false,
    dateFormatter,
    toDetails = null,
    ...remains
  } = props;

  const {
    containerNode,
    listNode,
    // moreBtnNode,
    max = 0, // 这里计算的max是把more按钮放进去之后计算能展示多少个产品的
  } = useLogoListCalc(logos?.length);

  // 显示了more按钮的话正常展示到max，没有展示more按钮的话多展示一个出来
  const displayLogos = logos?.slice(0, logos?.length > max + 1 ? max : max + 1);

  const [moreVisible, setMoreVisible] = useState(false);
  const [changeRanderModal, setChangeRanderModal] = useState<number>(0);

  // 弹窗显示时，文案折叠组件要重新刷新，防止弹窗未显示时，外面屏幕宽度发生变化，触发了折叠组件的handleResize事件，
  // 此时文案没有显示，获取到的宽高等信息都是0，导致计算结果有误，打开弹窗时，文案没有折叠
  useEffect(() => {
    if (moreVisible) {
      const t = setTimeout(() => {
        setChangeRanderModal(Date.now());
        clearTimeout(t);
      }, 0);
    }
  }, [moreVisible]);

  return (
    <div
      {...remains}
      ref={containerNode}
      style={style}
      className={classnames('dbg-studio-overall-logo-list-comp', className)}
    >
      <ul ref={listNode} className="dbg-studio-overall-logo-list">
        {displayLogos?.length > 0 &&
          displayLogos?.map((logo, idx) => (
            <li key={idx} className="dbg-studio-overall-logo-item">
              <InfoBubble
                className="globalpedia-modal-font14"
                placementOffset={10}
                customBubbleContent={getBubbleMsg?.(logo) || logo?.name}
                DomOrText={
                  <>
                    <GeneralImageNew
                      src={logo?.cover || ''}
                      errorImg={defaultLogo}
                      width={34}
                      height={34}
                      className="dbg-studio-overall-logo-img"
                    />
                  </>
                }
              />
            </li>
          ))}
      </ul>
      {logos?.length > displayLogos?.length && (
        <div className="dbg-studio-overall-logo-list-more-box">
          {/* <span className="dbg-studio-overall-logo-list-more-btn-shade"></span> */}
          <button
            // ref={moreBtnNode}
            className="dbg-studio-overall-logo-list-more-btn"
            onClick={() => {
              setMoreVisible(true);
            }}
          >
            <span>+{logos?.length - displayLogos?.length}</span>
            {/* <Iconfont
              type="title-arrow"
              className="dbg-studio-overall-logo-list-more-btn-arrow-icon"
            /> */}
          </button>
        </div>
      )}
      <GeneralModal
        className="dbg-studio-overall-logo-list-details-modal globalpedia-custom-scrollbar"
        isFont14={true}
        isFooter={true}
        title={title}
        modalSize={600}
        visible={moreVisible}
        destroyOnClose={false}
        footerButtonGroup={['close']}
        content={
          <LogoListDetails
            key={changeRanderModal}
            logos={logos}
            defaultLogo={defaultLogo}
            isShowDate={isModalShowItemDate}
            dateFormatter={dateFormatter}
            toDetails={toDetails}
          />
        }
        onClose={() => {
          setMoreVisible(false);
        }}
      />
    </div>
  );
};

export default memo(LogoList);
